import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, createStaticVNode as a, normalizeClass as o, openBlock as s } from "vue";
//#region ../src/icons/office-365.vue
var c = {
	name: "DtIconOffice365",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, l = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], u = ["fill"], d = ["fill"], f = ["fill"], p = ["fill"], m = ["fill"], h = ["id"], g = ["id"], _ = ["id"], v = ["id"], y = ["id"];
function b(e, t, n, c, b, x) {
	return s(), r("svg", {
		"aria-label": n.ariaLabel,
		class: o([x.iconSizeClass, "d-icon d-icon--office-365"]),
		"data-qa": x.dataQA,
		"aria-hidden": x.ariaHidden,
		role: "img",
		"data-name": "Office 365",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("path", {
			d: "m12.571 2.069 1.366 3.597v12.297l-1.333 3.97 5.902-1.639a1.904 1.904 0 0 0 1.393-1.834V5.542a1.903 1.903 0 0 0-1.396-1.835L12.571 2.07z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, u),
		i("path", {
			d: "m7.239 16.878-1.757.96A1.001 1.001 0 0 1 4 16.96V7.45a1.9 1.9 0 0 1 .954-1.65l6.192-3.553a1.869 1.869 0 0 1 1.642-.107 1.86 1.86 0 0 1 1.15 1.724v1.8L8.904 7.5a1.415 1.415 0 0 0-.93 1.33v6.807a1.415 1.415 0 0 1-.736 1.24z",
			fill: `url(#${e.uniqueID}b)`
		}, null, 8, d),
		i("path", {
			d: "M13.937 17.963v2.214a1.82 1.82 0 0 1-2.713 1.59l-3.88-2.174a.87.87 0 0 1 .425-1.63h6.168z",
			fill: `url(#${e.uniqueID}c)`
		}, null, 8, f),
		i("path", {
			d: "m7.239 16.878-1.757.96A1.001 1.001 0 0 1 4 16.96V7.45a1.9 1.9 0 0 1 .954-1.65l6.192-3.553a1.869 1.869 0 0 1 1.642-.107 1.86 1.86 0 0 1 1.15 1.724v1.8L8.904 7.5a1.415 1.415 0 0 0-.93 1.33v6.807a1.415 1.415 0 0 1-.736 1.24z",
			fill: `url(#${e.uniqueID}d)`
		}, null, 8, p),
		i("path", {
			d: "M13.937 17.963v2.214a1.82 1.82 0 0 1-2.713 1.59l-3.88-2.174a.87.87 0 0 1 .425-1.63h6.168z",
			fill: `url(#${e.uniqueID}e)`
		}, null, 8, m),
		i("defs", null, [
			i("linearGradient", {
				id: `${e.uniqueID}a`,
				x1: "16.235",
				y1: ".94",
				x2: "16.235",
				y2: "20.54",
				gradientUnits: "userSpaceOnUse"
			}, [...t[0] || (t[0] = [a("<stop stop-color=\"#FFB900\"></stop><stop offset=\".166\" stop-color=\"#EF8400\"></stop><stop offset=\".313\" stop-color=\"#E25C01\"></stop><stop offset=\".429\" stop-color=\"#DB4401\"></stop><stop offset=\".5\" stop-color=\"#D83B01\"></stop>", 5)])], 8, h),
			i("linearGradient", {
				id: `${e.uniqueID}b`,
				x1: "12.782",
				y1: "1.762",
				x2: "2.29",
				y2: "16.747",
				gradientUnits: "userSpaceOnUse"
			}, [...t[1] || (t[1] = [a("<stop stop-color=\"#800600\"></stop><stop offset=\".6\" stop-color=\"#C72127\"></stop><stop offset=\".728\" stop-color=\"#C13959\"></stop><stop offset=\".847\" stop-color=\"#BC4B81\"></stop><stop offset=\".942\" stop-color=\"#B95799\"></stop><stop offset=\"1\" stop-color=\"#B85BA2\"></stop>", 6)])], 8, g),
			i("linearGradient", {
				id: `${e.uniqueID}c`,
				x1: "7.462",
				y1: "19.982",
				x2: "20.393",
				y2: "19.982",
				gradientUnits: "userSpaceOnUse"
			}, [...t[2] || (t[2] = [i("stop", { "stop-color": "#F32B44" }, null, -1), i("stop", {
				offset: ".6",
				"stop-color": "#A4070A"
			}, null, -1)])], 8, _),
			i("linearGradient", {
				id: `${e.uniqueID}d`,
				x1: "12.997",
				y1: "1.455",
				x2: "10.775",
				y2: "4.629",
				gradientUnits: "userSpaceOnUse"
			}, [...t[3] || (t[3] = [i("stop", { "stop-opacity": ".4" }, null, -1), i("stop", {
				offset: "1",
				"stop-opacity": "0"
			}, null, -1)])], 8, v),
			i("linearGradient", {
				id: `${e.uniqueID}e`,
				x1: "16.26",
				y1: "20.268",
				x2: "10.46",
				y2: "19.761",
				gradientUnits: "userSpaceOnUse"
			}, [...t[4] || (t[4] = [i("stop", { "stop-opacity": ".4" }, null, -1), i("stop", {
				offset: "1",
				"stop-opacity": "0"
			}, null, -1)])], 8, y)
		])
	], 10, l);
}
var x = /* @__PURE__ */ n(c, [["render", b]]);
//#endregion
export { x as default };

//# sourceMappingURL=office-365.js.map